module.exports = __webpack_public_path__ + "img/illustration-signin.feec7647.jpg";